<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                        <span>{{messError}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_name.label"
                                                :id="dataSearch.warehouse_name.id"
                                                :placeholder="dataSearch.warehouse_name.placeholder"
                                                :value-default="dataSearch.warehouse_name.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_name.id)"
                                                :required="dataSearch.warehouse_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_code.label"
                                                :id="dataSearch.warehouse_code.id"
                                                :placeholder="dataSearch.warehouse_code.placeholder"
                                                :value-default="dataSearch.warehouse_code.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_code.id)"
                                                :required="dataSearch.warehouse_code.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_addr.label"
                                                :id="dataSearch.warehouse_addr.id"
                                                :placeholder="dataSearch.warehouse_addr.placeholder"
                                                :value-default="dataSearch.warehouse_addr.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_addr.id)"
                                                :required="dataSearch.warehouse_addr.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_phone.label"
                                                :id="dataSearch.warehouse_phone.id"
                                                :placeholder="dataSearch.warehouse_phone.placeholder"
                                                :value-default="dataSearch.warehouse_phone.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_phone.id)"
                                                :required="dataSearch.warehouse_phone.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchWarehouse"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listWarehouses.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                    :label="selectAction.label"
                                    :id="selectAction.id"
                                    :placeholder="selectAction.placeholder"
                                    :value-default="selectAction.value"
                                    :required="selectAction.required"
                                    :options="selectAction.options"
                                    @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                    <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="listWarehouses.length > 0" v-for="warehouse in listWarehouses" :key="warehouse.id">
                                    <td><InputCheckboxOne :id="warehouse.id" :value-default="checkItems[warehouse.id]" @inputValue="onChangeSelectItem($event, warehouse.id)" :checked="checkItems[warehouse.id]"></InputCheckboxOne></td>
                                    <td class="product-name"><p @click="showWarehouseDetail(warehouse.id)">{{warehouse.name}}</p></td>
                                    <td>{{warehouse.code}}</td>
                                    <td>{{warehouse.phone}}</td>
                                    <td>{{warehouse.productCount}}</td>
                                    <td>{{warehouse.totalQuantity}}</td>
                                    <td>{{warehouse.address}}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="7" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listWarehouses.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<LoadingComponent v-if="isLoading"></LoadingComponent>

